/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import DashNavbar from '../../navbar/Navbar'
import DashMenu from '../../menu/DashMenu'
import DashFooter from '../../footer/DashFooter'
import { toast, ToastContainer } from 'react-toastify'
import { GlobalState } from '../../../../../globalState'
import { useSelector } from 'react-redux'
import axios from 'axios'
import i18n from '../../../../../i18n'
import { useTranslation } from 'react-i18next'
import { appAddress } from '../../../../../App'

export default function DeleteProject() {
  const {t} = useTranslation()
  
  const state = useContext(GlobalState);
  const [token] = useSelector((state) => state.token);
  const [projects, setProjects] = useState([]);
  const [callback, setCallback] = state.projectsAPI.callback;

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    i18n.changeLanguage(savedLanguage);

    const rootElement = document.getElementById('root');
    if (savedLanguage === 'fa' || savedLanguage === 'ar') {
      rootElement.classList.remove('ltr', 'text-left');
      rootElement.classList.add('rtl', 'text-right');
    } else {
      rootElement.classList.remove('rtl', 'text-right');
      rootElement.classList.add('ltr', 'text-left');
    }
  }, []);

  const fetchProjects = async () => {
    try {
      const res = await axios.get(`${appAddress}/api/projects`, {
      // const res = await axios.get('/api/projects', {
        headers: { Authorization: token },
      });
      setProjects(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, [callback]);

  const DeleteProject = async (projectId) => {
    try {
        const res = await axios.delete(`${appAddress}/api/projects/${projectId}`, {
        // const res = await axios.delete(`/api/projects/${projectId}`, {
            headers: { Authorization: token },
        });

        toast.success(res.data.msg, {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

        setCallback(!callback); 
    } catch (err) {
        console.error('Error deleting project:', err.response ? err.response.data : err); // Enhanced error logging
        const errorMessage = err.response?.data?.msg || 'An error occurred';
        toast.error(errorMessage, {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }
};


  return (
    <div className='bg-[#2a3447] text-teal-50 ltr'>
       <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <DashNavbar />
      <div className='flex mt-11'>
        <div className='w-[250px] p-5 border-r-4 '>
          <DashMenu />
        </div>
        <div className='p-4 w-[100%] flex flex-col items-center font-englishTitle'>
          <h2 className='text-3xl'>{t("DeleteProject")}</h2>
          <hr className='bg-slate-500 w-[20%] mb-6 mt-3' />
          <div className='w-[95%] grid grid-cols-2 laptop:grid-cols-2 desktop:grid-cols-4 desktopXL:grid-cols-5 items-center'>
            {Array.isArray(projects) && projects.length > 0 ? (
              projects.map((project) => (
                <div key={project._id} className='border m-auto mt-4 mb-3 w-[250px] laptop:w-[280px] desktop:w-[300px] flex flex-col justify-between p-2 border-b border-slate-300 items-center'>
                  <h4 className='mb-4 text-xl text-orange-500 uppercase font-persianTitle'>{project.title}</h4>
                  <img src={project.images[0]} className='w-[100%] h-[200px]' alt={project.title} />
                  <button onClick={() => DeleteProject(project._id)} className='w-[40%] p-2 mt-2 text-white hover:text-white bg-red-700 hover:bg-slate-900 rounded-lg'>
                    {t("Delete")}
                  </button>
                </div>
              ))
            ) : (
              <p>{t("NoProject")}</p>
            )}
          </div>
        </div>
      </div>
      <div className='mt-11'>
      <DashFooter />
      </div>
    </div>
  )
}
